import * as React from "react";

const IconPaginationBlockLeftInactive: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><g fill="none" fillRule="evenodd"><path fill="currentColor" d="M0 0h24v24H0z"/><path fill="#FFF" fillRule="nonzero" d="M5.533 12.545L5 12.002l.533-.544 4.813-4.914.532-.544 1.062 1.085-.532.543-3.528 3.606H19v1.535H7.88l3.531 3.603.533.543L10.881 18l-.532-.544z"/></g></svg>;
};

export default React.memo(IconPaginationBlockLeftInactive);
